import React from 'react'
import moment from 'moment'
import { Table } from '../../../dpe-usco'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'

const ContractHistoryWidget = ({ contractHistoryData,contractState, status, contractOriginated, contractStartDate }) => {

  const headerCell = value => {
    return (
      <div key={value} className='cell df aic'>
        <span>{value}</span>
      </div>
    )
  }
  const structure = {
    headers: [
      {
        value: 'Name',
        format(){
          return headerCell(this.value)
        }
      },
      { 
        value: 'Email',
        format(){
          return headerCell(this.value)
        }
      },
      { 
        value: 'Assigned in',
        format(){
          return headerCell(this.value)
        }
      },
      { 
        value: 'Date',
        format(){
          return headerCell(this.value)
        }
      }
    ],
    dataKeys: [
      'user_name',
      'user_email',
      'system_name',
      'edit_date_time'
    ],
    showTooltip:true,
    rowFormat: {
      edit_date_time: {
        format: dateVal => {
          return(<div className=''>{moment(dateVal).format('MMMM Do YYYY, h:mm:ss a')}</div>)
        },
        customStyle: 'wspun'
      }
    }
  }

  const stewardshipStructure = {
    headers: [
      {
        value: 'Name',
        format(){
          return headerCell(this.value)
        }
      },
      { 
        value: 'Email',
        format(){
          return headerCell(this.value)
        }
      },
      { 
        value: 'Action',
        format(){
          return headerCell(this.value)
        }
      },
      { 
        value: 'Date',
        format(){
          return headerCell(this.value)
        }
      }
    ],
    dataKeys: [
      'user_name',
      'user_email',
      'action',
      'edit_date_time'
    ],
    showTooltip:true,
    rowFormat: {
      edit_date_time: {
        format: dateVal => {
          return(<div className=''>{moment(dateVal).format('MMMM Do YYYY, h:mm:ss a')}</div>)
        },
        customStyle: 'wspun'
      }
    }
  }
  
  const content = (contractData, title = '', system_name ='',  contractStartDate) => {
    let displayDate = 'N/A'
    if(contractStartDate && title === 'Created by') {
      displayDate = moment(contractStartDate).format('MMMM Do YYYY, h:mm:ss a')
    } else if (title === 'Voided by') {
      displayDate = moment(contractData.voided_date_time).format('MMMM Do YYYY, h:mm:ss a')
    } else if (title === 'Deleted by') {
      displayDate = moment(contractData.deleted_date_time).format('MMMM Do YYYY, h:mm:ss a')
    } else if (title === 'Amended by') {
      displayDate = moment(contractData.amended_date_time).format('MMMM Do YYYY, h:mm:ss a')
    }
    let renderContent = (
      <>
        <div className="df jcsb mt15 mb5 fz15 fw600">{title}</div>
        <div><span className="tal fz13 c-darkgray fw600">Name:</span> <span className="fz15">{contractData.user_name?contractData.user_name:'N/A'}</span></div>
        <div><span className="tal fz13 c-darkgray fw600">Email:</span> <span className="fz15">{contractData.user_email?contractData.user_email:'N/A'}</span></div>
        <div>
          <span className="tal fz13 c-darkgray fw600">
            {title === 'Created by' && 'Created in: ' }
            {title === 'Voided by' && 'Voided in: ' }
            {title === 'Deleted by' && 'Deleted in: ' }
            {title === 'Amended by' && 'Amended in: ' }
          </span> 
          <span className="fz15">{system_name?system_name:'N/A'}</span>
        </div>
        <div>
          <span className="tal fz13 c-darkgray fw600">Date: </span> 
          <span className="fz15">{displayDate}</span>
        </div>
      </>
    ) 
    return renderContent
  }

  const contentWhenHistoryNotFound = (title = '', system_name ='',  contractStartDate) => {
    let displayDate = 'N/A'
    if(contractStartDate && title === 'Created by') {
      displayDate = moment(contractStartDate).format('MMMM Do YYYY, h:mm:ss a')
    } 
    let renderContent = (
      <>
        <div className="df jcsb mt15 mb5 fz15 fw600">{title}</div>
        <div>
          <span className="tal fz13 c-darkgray fw600">Created in: </span> 
          <span className="fz15">{system_name?system_name:'N/A'}</span>
        </div>
        <div>
          <span className="tal fz13 c-darkgray fw600">Date: </span> 
          <span className="fz15">{displayDate}</span>
        </div>
      </>
    ) 
    return renderContent
  }
  
  return (
    <Widget
      dataTestId='contractHistoryWidget'
      title={'Contract History'}
    >
      <div >
        {status ? <TableStatus status={status} /> : 
          contractHistoryData === 'null' ? contentWhenHistoryNotFound('Created by', contractOriginated, contractStartDate)
            :
            <>
              { contractHistoryData?.created_user_info && content(contractHistoryData?.created_user_info, 'Created by', contractOriginated, contractStartDate) }
              { contractState === 'voided' && contractHistoryData?.voided_user_info && content(contractHistoryData?.voided_user_info, 'Voided by', contractHistoryData?.voided_user_info?.system_name) }
              { contractHistoryData?.amended_user_info && content(contractHistoryData?.amended_user_info, 'Amended by', contractHistoryData?.amended_user_info?.system_name) }
              { contractHistoryData?.deleted_user_info && content(contractHistoryData?.deleted_user_info, 'Deleted by', contractHistoryData?.deleted_user_info?.system_name) }
              
              {
                contractHistoryData?.assign_fields_user_info && 
              <>
                <div className="df jcsb mt15 mb10 fz15 fw600">Assign fields by</div>
                <Table structure={structure} data={contractHistoryData?.assign_fields_user_info || []}/>
              </>
              }
              {
                contractHistoryData?.stewardship_history && contractHistoryData?.stewardship_history.length > 0 && 
              <>
                <div className="df jcsb mt15 mb10 fz15 fw600">Stewardship history</div>
                <Table structure={stewardshipStructure} data={contractHistoryData?.stewardship_history || []}/>
              </>
              }
            </>
        }
      </div>
      
    </Widget>
  )
}

export default ContractHistoryWidget